import lottie from 'lottie-web';
export default {
  props: {
    jsonUrl: {
      // json链接地址
      type: String
    },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      jsonData: ''
    };
  },
  async mounted() {
    if (this.jsonUrl) {
      await this.getJson();
    }
    this.anim = lottie.loadAnimation({
      container: this.$refs.lottieContainer,
      // 绑定DOM容器
      renderer: 'svg',
      // 渲染模式（svg/canvas/html）
      loop: this.loop,
      // 循环播放
      autoplay: true,
      // 自动播放
      animationData: this.jsonData // JSON动画路径（或直接传animationData）
    });
    // 监听动画完成事件
    this.anim.addEventListener('complete', this.onAnimationComplete);
  },
  methods: {
    async getJson() {
      const response = await fetch(this.jsonUrl);
      this.jsonData = await response.json();
    },
    // 动画播放完，回调
    onAnimationComplete() {
      this.$emit('onAnimationComplete');
    }
  },
  unmounted() {
    this.anim.removeEventListener('complete', this.onAnimationComplete);
  }
};